module.exports = __webpack_public_path__ + "static/media/P21.43520056.jpg";